import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import * as $ from 'jquery';
import { throwError } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { User } from 'src/app/model/user';
import { FclLoginService } from 'src/app/services/fcllogin.service';
import { OktaConfig } from '@okta/okta-angular/src/okta/models/okta.config';
import { environment } from 'src/environments/environment';
import { NavService } from 'src/app/services/nav.service';
import { CommonService } from 'src/app/services/common.service';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isAuthenticated: boolean;
  loginForm: FormGroup;
  JSON: JSON;
  fclLoginErrMsg: any;
  userManagementError: string;
  serviceError: string;
  user: User;
  internalUserInactive = false;
  pendingApproval = false;
  windowWidth: string;
  signIn: any;
  gatewayAccessToken = '';
  spinnerValue=false;

  constructor(
    public oktaAuth: OktaAuthService,
    private router: Router,
    public commonService: CommonService,
    private serviceTitle: Title,
    private changeDetectorRef: ChangeDetectorRef,
    private navService: NavService,
    public fclLoginService: FclLoginService) {
    this.oktaAuth.$authenticationState.subscribe(isAuthenticated => this.isAuthenticated = isAuthenticated);
    this.JSON = JSON;
    this.changeDetectorRef.markForCheck();
  }

  async ngOnInit() {
    this.fclLoginService.notValidUser$.next(true);
    this.deleteAllCookies();
    const userType = this.fclLoginService.getUserType();
    this.windowWidth = '-' + window.innerWidth + 'px';
    this.serviceError = undefined;
    this.fclLoginService.getGatewayAccessToken().subscribe((accessTokenResponse) => {
      this.gatewayAccessToken = accessTokenResponse.access_token;
      localStorage.setItem('gateway-access-token', accessTokenResponse.access_token);
    });

    this.loginForm = new FormGroup({
      j_username: new FormControl('', [Validators.required, Validators.minLength(6)]),
      j_password: new FormControl('', [Validators.required]),
    });
    if (this.fclLoginService.getUserType() === 'I' || this.fclLoginService.getUserType() === 'T') {
      this.isAuthenticated = await this.oktaAuth.isAuthenticated();
      this.changeDetectorRef.markForCheck();

      this.serviceTitle.setTitle('FSC Customer Portal');
      const accessToken = await this.oktaAuth.getAccessToken();
      if (this.isAuthenticated && this.fclLoginService.getUserType() === 'I') {
        const user = new User();
        await this.oktaAuth.getUser().then(
          (userClaims) => {
            user.userName = userClaims.name;
            user.lastName = userClaims.family_name;
            user.firstName = userClaims.given_name;
            user.preferredUsername = userClaims.preferred_username;
            user.jwtToken = accessToken;
            if (userClaims !== undefined && userClaims.preferred_username !== undefined) {
              const preferredUsr = userClaims.preferred_username.split('@');
              if (preferredUsr !== undefined && preferredUsr.length > 1) {
                user.fedExId = preferredUsr[0];
              }

              if (preferredUsr.length === 1) {
                user.fedExId = preferredUsr[0];
              }
            } else {
              user.fedExId = userClaims.preferred_username;
            }
            user.userInternalOrExternal = 'I';
            this.fclLoginService.populateUserInfo(user);
          }
        );

        this.navService.deleteAllCookies();
        this.fclLoginService.validateUser(accessToken).subscribe(
          (fscExternalUserResponse) => {
            if (fscExternalUserResponse.user.approvalStatus === '0') {
              this.pendingApproval = true;
              this.userManagementError = undefined;
              this.logout();
            } else if (fscExternalUserResponse.user.approvalStatus === '2') {
              this.internalUserInactive = true;
              this.userManagementError = undefined;
            } else {
              this.userLastLoginTimeUpdate(fscExternalUserResponse.user.id);
              if(fscExternalUserResponse.user.locale){
                this.mappinglang(fscExternalUserResponse.user.locale);
              } else {
                localStorage.setItem('userDBLang', 'en');
                localStorage.setItem('userTempLang', 'en');
              }
              // this.commonService.selLang = fscExternalUserResponse.user.locale;
              localStorage.setItem('USER-ID', ''+ fscExternalUserResponse.user.id);
              this.router.navigate(['home']);
              this.fclLoginService.notValidUser$.next(false);
            }
          }, (error: HttpErrorResponse) => {
            console.log(error.error);
            if (userType !== null && userType !== undefined) {
              this.serviceError = 'Trouble logging in, try later';
            }
            this.isAuthenticated = false;
          }
        );
        
      } else if (this.isAuthenticated && this.fclLoginService.getUserType() === 'T') {
        const user = new User();
        await this.oktaAuth.getUser().then(
          (userClaims) => {
            user.okTempUserId = userClaims.sub;
            user.userInternalOrExternal = 'T';
            user.jwtToken = accessToken;
            this.fclLoginService.populateUserInfo(user);
          }, (error: HttpErrorResponse) => {
            console.log(error.error);
            if (userType !== null && userType !== undefined) {
              this.serviceError = 'Trouble logging in, try later';
              this.fclLoginService.oktaAuth.logout('/');
            }
            this.isAuthenticated = false;
          }
        );

        this.navService.deleteAllCookies();
        this.fclLoginService.validateUser(accessToken).subscribe(
          (fscExternalUserResponse) => {
            if (fscExternalUserResponse.user.approvalStatus === '0') {
              this.pendingApproval = true;
              this.userManagementError = undefined;
              this.logout();
            } else if (fscExternalUserResponse.user.approvalStatus === '2') {
              user.userName = fscExternalUserResponse.user.firstName + ' ' + fscExternalUserResponse.user.lastName;
              user.lastName = fscExternalUserResponse.user.lastName;
              user.firstName = fscExternalUserResponse.user.firstName;
              user.preferredUsername = user.userName;
              user.locale = fscExternalUserResponse.user.locale;
              user.loginId = fscExternalUserResponse.user.loginId;
              user.jwtToken = accessToken;
              this.internalUserInactive = true; // need to work
              this.userManagementError = undefined;
              this.fclLoginService.populateUserInfo(user);
            } else {
              user.userName = fscExternalUserResponse.user.firstName + ' ' + fscExternalUserResponse.user.lastName;
              user.lastName = fscExternalUserResponse.user.lastName;
              user.firstName = fscExternalUserResponse.user.firstName;
              user.preferredUsername = user.userName;
              user.locale = fscExternalUserResponse.user.locale;
              user.loginId = fscExternalUserResponse.user.loginId;
              user.jwtToken = accessToken;
              this.internalUserInactive = true; // need to work
              this.userManagementError = undefined;
              this.userLastLoginTimeUpdate(fscExternalUserResponse.user.id);
              this.fclLoginService.populateUserInfo(user);
              
              if(fscExternalUserResponse.user.locale){
                this.mappinglang(fscExternalUserResponse.user.locale);
              } else {
                localStorage.setItem('userDBLang', 'en');
                localStorage.setItem('userTempLang', 'en');
              }
              localStorage.setItem('USER-ID', ''+ fscExternalUserResponse.user.id);
              this.router.navigate(['home']);
              this.fclLoginService.notValidUser$.next(false);
            }
          }, (error: HttpErrorResponse) => {
            console.log(error.error);
            if (userType !== null && userType !== undefined) {
              this.serviceError = 'Trouble logging in, try later';
            }
            this.isAuthenticated = false;
          }
        );
      }
    }

    if (this.getCookie("fcl_fname")) {
      console.log(this.getCookies("fcl_uuid"));
      if (this.getCookies("fcl_uuid") && this.getCookies("fcl_uuid").length === 2) {
        this.navService.deleteAllCookies();
      } else {
        this.fclLogin();
      }
    }

  }

  mappinglang(lang){
    switch (lang) {
      case 'en':
        localStorage.setItem('userDBLang', 'en');
        localStorage.setItem('userTempLang', 'en');
        break;
      case 'pr':
        localStorage.setItem('userDBLang', 'pr');
        localStorage.setItem('userTempLang', 'pr');
        break;
      default:
        ''
    }

  }

  login(userType) {
    this.fclLoginService.clearDuringLogin();
    this.fclLoginService.setUserType(userType);

    if (userType === 'I') {
      this.deleteAllCookies();
      const oktaConfig = {
        issuer: environment.oktaIssuer,
        clientId: environment.oktaClientId,
        redirectUri: environment.oktaURL + '/authorization-code/callback',
        pkce: true,
        scopes: environment.oktaScopes
      };

      this.oktaAuth = this.createOktaService(oktaConfig);
      this.navService.oktaState$.next(this.oktaAuth);
      this.oktaAuth.loginRedirect();

    } else {
      // window.location.href = 'https://purpleid-partners-stage.oktapreview.com/';
      this.deleteAllCookies();
      const oktaConfig = {
        issuer: environment.oktaTempIssuer,
        clientId: environment.oktaTempClientId,
        redirectUri: environment.oktaURL + '/authorization-code/callback',
        pkce: true
      };

      this.oktaAuth = this.createOktaService(oktaConfig);
      this.navService.oktaState$.next(this.oktaAuth);
      this.oktaAuth.loginRedirect();
    }

  }

  createOktaService(config: OktaConfig): OktaAuthService {
    return new OktaAuthService(config, this.router);
  }

  async fclLogin() {
    this.spinnerValue=true;
    this.fclLoginService.setUserType('E');
    this.userManagementError = undefined;
    const user = new User();
    this.fclLoginService.clearDuringLogin();
    localStorage.setItem('gateway-access-token', this.gatewayAccessToken);
    //get data from cookies
    user.firstName = this.getCookie("fcl_contactname");
    user.userInternalOrExternal = 'E';
    user.fclContactname = this.getCookie("fcl_contactname");
    user.fdxLogin = this.getCookie("fdx_login");
    user.fclFname = this.getCookie("fcl_fname");
    user.fclUuid = this.getCookie("fcl_uuid");
    this.fclLoginService.setUserType('E');
    //api call to get UserInfo related token
    await this.fclLoginService.fclUserInfoToken().toPromise().then(res => {
      user.fclAuthToken = res.access_token;
    },
    err=>{
      this.spinnerValue=false;
      this.userManagementError='Failed while generating token';
      console.log(err);
    });
    this.user = user;
    this.fclLoginService.populateUserInfo(this.user);
    //API to get userInfo == loginId
    await this.fclLoginService.getFCLUserInfo().toPromise().then(res => {
      user.loginId = res.output.userProfile.loginInformation.userId;
    },
    err=>{
      this.spinnerValue=false;
      this.userManagementError='Failed while getting userInfo';
      console.log(err);
      this.navService.deleteAllCookies();
    });
    //api call to get validateUser related token
    await this.fclLoginService.fclAccessToken().toPromise().then(res => {
      user.fclAuthToken = res.access_token;
    },
    err=>{
      this.spinnerValue=false;
      this.userManagementError='Failed while generating token';
      console.log(err);
    });
    this.user = user; // Just set locally
    this.fclLoginService.populateUserInfo(this.user);
    this.fclLoginService.isUserLoggedIn = true;
    await this.fclLoginService.validateUser(user.loginId).toPromise().then(validateUserRes => {
      this.spinnerValue=false;
      let routePath = '';
        if (validateUserRes.success &&
          (validateUserRes.errors === undefined || validateUserRes.errors.length === 0)) {
          if (validateUserRes.user.approvalStatus === '2') {
            this.userManagementError = 'Your account is inactive';
            this.internalUserInactive = false;
          } else {            
            if(validateUserRes.user.locale){
              this.mappinglang(validateUserRes.user.locale);
            } else {
              localStorage.setItem('userDBLang', 'en');
              localStorage.setItem('userTempLang', 'en');
            }
            localStorage.setItem('USER-ID', '' + validateUserRes.user.id);
            this.userLastLoginTimeUpdate(validateUserRes.user.id);
            routePath = 'home';
            this.user = validateUserRes.user;
            this.user.userInternalOrExternal = 'E';
            this.user.fclContactname = user.fclContactname;
            this.user.fdxLogin = user.fdxLogin;
            this.user.fclFname = user.fclFname;
            this.user.fclUuid = user.fclUuid;
            this.user.fclAuthToken = user.fclAuthToken;           
            this.fclLoginService.populateUserInfo(this.user);
          }
        } else {
          this.fclLoginService.populateUserInfo(this.user);
          if (validateUserRes.errors.length !== 0) {
            for (const error of validateUserRes.errors) {
              if (error.code === 'ERR-FUM-1005') {
                routePath = 'registration'; // User Not Registered
                break;
              } else if (error.code === 'ERR-FUM-1003') {
                routePath = '/'; // Role(s) not configured for user
                this.userManagementError = 'Your registration was successful,once approved you are able to login';
                break;
              }
            }
          } else if (validateUserRes.user && validateUserRes.user.approvalStatus === 'P') {
            routePath = '/'; // Role(s) not configured for user
            this.userManagementError = 'Your registration was successful,once approved you are able to login';
          }
        }
        this.spinnerValue=false;
        if (routePath !== '') {
          this.router.navigateByUrl(routePath);
          this.fclLoginService.notValidUser$.next(false);
        }
    }, error => {
      this.spinnerValue=false;
      if (error instanceof HttpErrorResponse) {
        this.userManagementError = 'Invalid Credentials.';
      } else {
        this.fclLoginErrMsg = error;
      }
    });
    this.spinnerValue=false;
  }  

  userLastLoginTimeUpdate(usrId: any) {    
    this.fclLoginService.updateUserAndFacilityLastLoginTime(usrId.toString(), null).subscribe(
      res => {
        if (!res.success) {
          this.serviceError = 'Trouble updating user last login time, try later';
          this.fclLoginService.oktaAuth.logout('/');
        }
      }
    );
  }

  otheruser() {
    this.fclLoginService.clearDuringLogin();
    const otheraccrdtoggle = $('#lo').attr('class');
    if (otheraccrdtoggle !== 'collapse in') {
      document.getElementById('loginarrow1').style.transform = 'rotate(90deg)';
      document.getElementById('fx-login').style.height = '565px';
      document.getElementById('loginOtherUser').style.maxHeight = '16em';
    } else {
      document.getElementById('loginarrow1').style.transform = 'rotate(0deg)';
      document.getElementById('fx-login').style.height = '437px';
    }
  }

  async logout() {
    this.deleteAllCookies();
    await this.oktaAuth.logout();
    this.router.navigateByUrl('/');

    if (this.fclLoginService.getUserType() === 'I' || this.fclLoginService.getUserType() === 'T') {
      this.fclLoginService.user = undefined;
      this.fclLoginService.clearLocalStorage();
      this.deleteAllCookies();
      setTimeout(() => {
        this.oktaAuth.logout('/');
      }, 200);
    } else if (this.fclLoginService.getUserType() === 'E') {
      this.fclLoginService.user = undefined;
      this.fclLoginService.isUserLoggedIn = false;
      this.navService.deleteAllCookies();
      this.fclLoginService.clearLocalStorage();
    }
  }

  deleteAllCookies() {
    // const cookies = document.cookie.split(';');
    // for (const cookie of cookies) {
    //   const cookieName = cookie.split('=')[0];
    //   console.log('cookie nmae ----->'||cookie);

    //   if (
    //       cookieName !== 'okta-oauth-nonce' && 
    //       cookieName !== 'okta-oauth-state' && 
    //       cookieName !== 'bm_sz' && 
    //       cookieName !== 'ak_bmsc' && 
    //       cookieName !== 'bm_sv' && 
    //       cookieName !== 'bm_mi' && 
    //       cookieName !== '_abck'
    //     ) {
    //     document.cookie = cookieName + "=;domain=.fedex.com;path=/;max-age=0";
    //   }
    // }
  }

  redirectUser() {
    // if (!this.getCookie("fcl_fname")) {
      this.navService.deleteAllCookies();
      this.redirectLocation();
    // }else{
    //   this.fclLogin();
    // }
  }

  redirectLocation() {
    window.location.href = environment.uiFCLURL + "secure-login/#/login-credentials?redirectUrl=" + window.location;
  }

  // Given a cookie key `name`, returns the value of
  // the cookie or `null`, if the key is not found.
  getCookie(name: string): string | null {
    const nameLenPlus = (name.length + 1);
    return document.cookie
      .split(';')
      .map(c => c.trim())
      .filter(cookie => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
      })
      .map(cookie => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || null;
  }

  // Given a cookie key `name`, returns the values of
  // the cookie or `null`, if the key is not found.
  getCookies(name: string): Array<string> | null {
    const nameLenPlus = (name.length + 1);
    return document.cookie
      .split(';')
      .map(c => c.trim())
      .filter(cookie => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
      })
      .map(cookie => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      }) || null;
  }
}

